import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";

import { isPostBookingRequirementForShift } from "./isPostBookingRequirementForShift";
import { isRequirementApplicableToShift } from "./isRequirementApplicableToShift";
import { isRequirementInValidForShift } from "./isRequirementInValidForShift";

interface FilterPostBookingRequirementsForShiftProps {
  workplace: {
    id: string;
    workplaceType?: string;
    msa?: string;
    state?: string;
    region?: string;
  };
  qualifications: string[];
  workplaceRequirements?: WorkerRequirement[];
}

export function filterPostBookingRequirementsForShift(
  props: FilterPostBookingRequirementsForShiftProps
): WorkerRequirement[] | undefined {
  const { workplace, qualifications, workplaceRequirements } = props;

  return workplaceRequirements?.filter((requirement) => {
    if (
      !isPostBookingRequirementForShift({ requirement, workplaceId: workplace.id, qualifications })
    ) {
      return false;
    }

    if (!isRequirementApplicableToShift({ requirement, workplace, qualifications })) {
      return false;
    }

    return (
      isRequirementInValidForShift({ requirement }) &&
      requirement.status !== WorkerRequirementStatus.IN_REVIEW
    );
  });
}
